import React, { useEffect, useState } from "react";
import { GrMail } from "react-icons/gr";
import { IoIosCall } from "react-icons/io";
import { FaUser, FaLock } from "react-icons/fa";
import { AiFillHeart, AiFillShopping, AiOutlineShoppingCart } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_card_products,
  get_wishlist_products,
  get_guest_wishlist_products,
} from "../store/reducers/cardReducer";

import { get_support_info } from "../store/reducers/authReducer";
import FloatingCartButton from "./FloatingCartButton";

const Headers = ({ sellerId, sellerName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo, supportInfo, seller } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );

  const { pathname } = useLocation();
  const [showShidebar, setShowShidebar] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (sellerId) {
      dispatch(get_support_info(sellerId));
    }
  }, [dispatch, sellerId]);
  useEffect(() => {
    if (sellerId) {
      if (userInfo && userInfo.id) {
        dispatch(get_card_products({ userId: userInfo.id, sellerId }));
        dispatch(get_wishlist_products(userInfo.id));
      } else {
        // For guest users, load cart and wishlist data using sessionId
        const sessionId = sessionStorage.getItem('guestSessionId');
        if (sessionId) {
          dispatch(get_card_products({ userId: null, sellerId, sessionId }));
          dispatch(get_guest_wishlist_products(sessionId));
        }
      }
    }
  }, [userInfo, sellerId]);

  if (!sellerName) {
    // Optionally log for debugging
    console.warn('Headers: sellerName is undefined');
    return null; // or return <div>Loading...</div>;
  }

  const search = () => {
    if (searchValue.trim()) {
      navigate(`/${sellerName}/products/search?value=${encodeURIComponent(searchValue.trim())}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      search();
    }
  };

  const clearSearch = () => {
    setSearchValue("");
  };

  const redirect_card_page = () => {
    navigate(`/${sellerName}/card`);
  };
  
  return (
    <div className="w-full bg-white">
      {/* Top Bar */}
      <div className="header-top bg-gray-50 border-b border-gray-100 md-lg:hidden">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="flex w-full justify-between items-center h-[40px] text-gray-600">
            <ul className="flex justify-start items-center gap-6">
              <li className="flex relative justify-center items-center gap-2 text-sm after:absolute after:h-[18px] after:w-[1px] after:bg-gray-200 after:-right-[12px] hover:text-indigo-600 transition-all duration-300">
                <span className="text-indigo-600">
                  <GrMail />
                </span>
                <span className="hover:scale-105 transition-transform duration-300">
                  <span className="text-gray-500">Email: </span>
                  {seller?.support?.email || "Contact us"}
                </span>
              </li>
              <li className="flex relative justify-center items-center gap-2 text-sm after:absolute after:h-[18px] after:w-[1px] after:bg-gray-200 after:-right-[12px] hover:text-indigo-600 transition-all duration-300">
                <span className="text-indigo-600">
                  <IoIosCall />
                </span>
                <span className="hover:scale-105 transition-transform duration-300">
                  <span className="text-gray-500">Phone: </span>
                  {seller?.support?.mobileNo || "Contact us"}
                </span>
              </li>

              <span className="text-sm hover:text-indigo-600 transition-all duration-300">
                <span className="text-gray-500">Shop: </span>
                {seller?.shopInfo?.shopName || "Multi vendor ecommerce"}
              </span>
            </ul>
            <div>
              <div className="flex justify-center items-center gap-6">
                {/*
                <div className="relative flex group cursor-pointer text-gray-600 text-sm justify-center items-center gap-1">
                  <img
                    src="/images/language.png"
                    alt="Language Icon"
                    className="w-4 h-4 object-contain hover:scale-110 transition-transform duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <div className="relative after:h-[18px] after:w-[1px] after:bg-gray-200 after:absolute after:-right-[12px] before:absolute before:h-[18px] before:bg-gray-200 before:w-[1px] before:-left-[12px]">
                    <ul className="absolute opacity-0 transition-all ease-in-out duration-300 transform -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 bg-white text-gray-800 p-2 w-[100px] flex flex-col gap-3 rounded-lg shadow-lg z-20">
                      <li className="hover:text-indigo-600 transition-colors duration-200">English</li>
                    </ul>
                  </div>
                </div>
                */}

                {userInfo ? (
                  <Link
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm hover:text-indigo-600 transition-all duration-300"
                    to={`/${sellerName}/dashboard`}
                  >
                    <span className="w-6 h-6 flex items-center justify-center text-indigo-600">
                      <FaUser />
                    </span>
                    <span>{userInfo.name}</span>
                  </Link>
                ) : (
                  <Link
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm hover:text-indigo-600 transition-all duration-300"
                    to={`/${sellerName}/dashboard`}
                  >
                    <span className="w-6 h-6 flex items-center justify-center text-indigo-600">
                      <AiOutlineShoppingCart />
                    </span>
                    <span>Track Order</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="h-[70px] md-lg:h-[80px] flex justify-between items-center flex-wrap">
            <div className="md-lg:w-full w-3/12 md-lg:pt-4">
              <Link to={`/${sellerName}`} className="block">
                <div className="w-[180px] h-[60px] relative">
                  <img
                    src={seller?.image || "/images/logo.png"}
                    alt={seller?.shopInfo?.shopName || "Store Logo"}
                    className="w-full h-full object-contain object-center"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/images/logo.png";
                    }}
                  />
                </div>
              </Link>
            </div>
            <div className="md-lg:w-full w-9/12">
              <div className="flex justify-between md-lg:justify-center items-center flex-wrap pl-8">
                <ul className="flex justify-start items-start gap-8 text-sm font-medium md-lg:hidden">
                  <li className="relative group">
                    <Link
                      className={`p-2 block transition-all duration-300 ${
                        pathname === "/" 
                          ? "text-indigo-600" 
                          : "text-gray-600 hover:text-indigo-600"
                      }`}
                      to={`/${sellerName}`}
                    >
                      Home
                      <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 transform scale-x-0 transition-transform duration-300 ${
                        pathname === "/" ? "scale-x-100" : "group-hover:scale-x-100"
                      }`}></span>
                    </Link>
                  </li>
                  <li className="relative group">
                    <Link
                      to={`/${sellerName}/products`}
                      className={`p-2 block transition-all duration-300 ${
                        pathname === "/products" 
                          ? "text-indigo-600" 
                          : "text-gray-600 hover:text-indigo-600"
                      }`}
                    >
                      All Products
                      <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 transform scale-x-0 transition-transform duration-300 ${
                        pathname === "/products" ? "scale-x-100" : "group-hover:scale-x-100"
                      }`}></span>
                    </Link>
                  </li>
                  {!userInfo && (
                    <li className="relative group">
                      <Link
                        to={`/${sellerName}/dashboard`}
                        className={`p-2 block transition-all duration-300 ${
                          pathname === "/dashboard" 
                            ? "text-indigo-600" 
                            : "text-gray-600 hover:text-indigo-600"
                        }`}
                      >
                        Track Order
                        <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-indigo-600 transform scale-x-0 transition-transform duration-300 ${
                          pathname === "/dashboard" ? "scale-x-100" : "group-hover:scale-x-100"
                        }`}></span>
                      </Link>
                    </li>
                  )}
                </ul>
                <div className="flex md-lg:hidden justify-center items-center gap-4">
                  <div className="flex justify-center gap-4">
                    {!userInfo && (
                      <div
                        onClick={() => navigate(`/${sellerName}/dashboard`)}
                        className="relative flex justify-center items-center cursor-pointer w-[36px] h-[36px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                        title="Track Order"
                      >
                        <span className="text-lg text-green-600">
                          <AiOutlineShoppingCart />
                        </span>
                      </div>
                    )}
                    <div
                      onClick={() =>
                        navigate(`/${sellerName}/dashboard/my-wishlist`)
                      }
                      className="relative flex justify-center items-center cursor-pointer w-[36px] h-[36px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                    >
                      <span className="text-lg text-red-500">
                        <AiFillHeart />
                      </span>
                      {wishlist_count !== 0 && (
                        <div className="w-[18px] h-[18px] absolute bg-indigo-600 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-medium">
                          {wishlist_count}
                        </div>
                      )}
                    </div>
                    <div
                      onClick={redirect_card_page}
                      className="relative flex justify-center items-center cursor-pointer w-[36px] h-[36px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                    >
                      <span className="text-lg text-indigo-600">
                        <AiFillShopping />
                      </span>
                      {card_product_count !== 0 && (
                        <div className="w-[18px] h-[18px] absolute bg-indigo-600 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-medium">
                          {card_product_count}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="w-[85%] lg:w-[90%] mx-auto py-4">
        <div className="flex w-full flex-wrap md-lg:gap-6">
          <div className="w-full">
            <div className="flex flex-wrap w-full justify-between items-center md-lg:gap-6">
              <div className="w-8/12 md-lg:w-full">
                <div className="flex border border-gray-200 h-[45px] items-center relative gap-5 rounded-lg overflow-hidden">
                  <input
                    className="w-full relative bg-transparent text-gray-600 outline-0 px-3 h-full"
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                    type="text"
                    name=""
                    id=""
                    placeholder="What do you need?"
                    onKeyDown={handleKeyPress}
                  />
                  {searchValue && (
                    <button
                      onClick={clearSearch}
                      className="absolute right-20 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                      type="button"
                    >
                      ✕
                    </button>
                  )}
                  <button
                    onClick={search}
                    className="bg-indigo-600 right-0 absolute px-8 h-full font-medium text-white hover:bg-indigo-700 transition-colors duration-200"
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className="w-4/12 block md-lg:hidden pl-2 md-lg:w-full md-lg:pl-0">
                <div className="w-full flex justify-end md-lg:justify-start gap-3 items-center">
                  <div className="w-[40px] h-[40px] rounded-full flex bg-gray-50 justify-center items-center text-indigo-600">
                    <span>
                      <IoIosCall />
                    </span>
                  </div>
                  <div className="flex justify-end flex-col gap-1">
                    <h2 className="text-sm font-medium text-gray-800">
                      <span className="text-gray-500">Phone: </span>
                      {seller?.support?.mobileNo || "Contact us"}
                    </h2>
                    <span className="text-xs text-gray-500">
                      <span className="text-gray-400">Hours: </span>
                      {seller?.support?.supportHours || "Support hours"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Cart Section */}
      <div className="md-lg:block hidden bg-white border-t border-gray-100 py-3">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              {!userInfo && (
                <div
                  onClick={() => navigate(`/${sellerName}/dashboard`)}
                  className="relative flex justify-center items-center cursor-pointer w-[40px] h-[40px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                  title="Track Order"
                >
                  <span className="text-xl text-green-600">
                    <AiOutlineShoppingCart />
                  </span>
                </div>
              )}
              <div
                onClick={() =>
                  navigate(`/${sellerName}/dashboard/my-wishlist`)
                }
                className="relative flex justify-center items-center cursor-pointer w-[40px] h-[40px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
              >
                <span className="text-xl text-red-500">
                  <AiFillHeart />
                </span>
                {wishlist_count !== 0 && (
                  <div className="w-[20px] h-[20px] absolute bg-indigo-600 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-medium">
                    {wishlist_count}
                  </div>
                )}
              </div>
              <div
                onClick={redirect_card_page}
                className="relative flex justify-center items-center cursor-pointer w-[40px] h-[40px] rounded-full bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
              >
                <span className="text-xl text-indigo-600">
                  <AiFillShopping />
                </span>
                {card_product_count !== 0 && (
                  <div className="w-[20px] h-[20px] absolute bg-indigo-600 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-medium">
                    {card_product_count}
                  </div>
                )}
              </div>
            </div>
            <div className="text-sm text-gray-600">
              <span className="text-gray-500">Cart: </span>
              {card_product_count} {card_product_count === 1 ? 'item' : 'items'}
            </div>
          </div>
        </div>
      </div>
      
      {/* Floating Cart Button */}
      <FloatingCartButton 
        sellerName={sellerName} 
        cardProductCount={card_product_count} 
      />
    </div>
  );
};

export default Headers;
